import { useSyncExternalStore } from 'react';

// Module-scoped shared state so the main Header and the store-page
// CondensedHeader can coordinate their visibility — when condensed is
// active the main header fades out to avoid a double-header stack.
let isActive = false;
const listeners = new Set();

const setActive = (next) => {
  const value = typeof next === 'function' ? next(isActive) : next;
  if (value === isActive) return;
  isActive = value;
  listeners.forEach((fn) => fn());
};

const subscribe = (cb) => {
  listeners.add(cb);
  return () => listeners.delete(cb);
};

const getSnapshot = () => isActive;

const useCondensedHeader = () => {
  const current = useSyncExternalStore(subscribe, getSnapshot);
  return {
    isActive: current,
    setActive,
  };
};

export default useCondensedHeader;
